import { gql } from '@apollo/client';

export const ImageEmbedFieldsFragment = gql`
  fragment ImageEmbedFields on ImageEmbed {
    id
    serveUrl
  }
`;

export const PostUploadConfigFieldsFragment = gql`
  fragment PostUploadConfigFields on PostUploadConfig {
    endpoint
    amzAlgorithm
    amzCredential
    amzDate
    amzSignature
    amzSecurityToken
    key
    policy
  }
`;
